/**
 * WordPress dependencies
 */
import { useSelect } from '@wordpress/data';
import { ColorPalette, BaseControl } from '@wordpress/components';
import { __experimentalColorGradientControl as ColorGradientControl } from '@wordpress/block-editor';
import { isEmpty } from 'lodash';

const ColorControl = ( props ) => {
	const { clearable = true } = props;
	const { colors } = useSelect( ( select ) => {
		return {
			colors: select( 'core/block-editor' ).getSettings().colors || [],
		};
	} );
	return (
		<BaseControl label={ props.label } id="textcolor-1">
			<ColorPalette
				colors={ colors }
				value={ props.value }
				onChange={ ( color ) => {
					props.onChange( color );
				} }
				clearable={ clearable }
			/>
		</BaseControl>
	);
};

const GradientColorControl = ( props ) => {
	const { clearable = true } = props;
	const { colors, gradients } = useSelect( ( select ) => {
		return {
			colors: select( 'core/block-editor' ).getSettings().colors || [],
			gradients: select( 'core/block-editor' ).getSettings().gradients || [],
		};
	} );

	const onGradientChange = ( val ) => {
		if ( isEmpty( val ) ) {
			return;
		}
		const styles = {
			backgroundGradient: val,
			backgroundColor: undefined,
		};
		props.onChange( styles );
	};
	const onColorChange = ( val ) => {
		if ( isEmpty( val ) ) {
			return;
		}
		const styles = {
			backgroundColor: val,
			backgroundGradient: undefined,
		};
		props.onChange( styles );
	};

	return (
		<div className="gutenify-color-gradient-control-wrapper">
			<ColorGradientControl
				label={ props.label }
				colorValue={ props.colorValue }
				gradientValue={ props.gradientValue }
				colors={ colors }
				gradients={ gradients }
				disableCustomColors={ false }
				disableCustomGradients={ false }
				onColorChange={ onColorChange }
				onGradientChange={ onGradientChange }
				clearable={ false }
			/>
			{ clearable &&
			<div className="components-circular-option-picker__custom-clear-wrapper"><button type="button" className="components-button components-circular-option-picker__clear is-secondary is-small" onClick={ () => {
				const styles = {
					backgroundColor: undefined,
					backgroundGradient: undefined,
				};
				props.onChange( styles );
			} }>Clear</button></div> }
		</div>
	);
};

export { ColorControl, GradientColorControl };
